export enum SubstringEndIndexOptions {
	ToEndOfValue = 1,
	StaticValue = 2,
	FirstIndexOf = 3,
	LastIndexOf = 4,
}
